import { PublicLayout } from '../layout/PublicLayout';
import { useSEO } from '@/hooks/useSEO';
import { LEGAL_CONFIG, LEGAL_ROUTES } from './legalConfig';
import { termsHtml } from './legalContent';

export const TermsOfServicePage = () => {
  useSEO({
    title: `Terms of Service - ${LEGAL_CONFIG.companyName}`,
    description: `Terms of Service - ${LEGAL_CONFIG.companyName}`,
    keywords: 'terms of service',
    ogTitle: `Terms of Service - ${LEGAL_CONFIG.companyName}`,
    ogDescription: `Terms of Service - ${LEGAL_CONFIG.companyName}`,
    ogType: 'website',
    canonicalUrl: `https://${LEGAL_CONFIG.domain}${LEGAL_ROUTES.terms}`,
  });

  return (
    <PublicLayout>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div
          className="prose prose-slate dark:prose-invert max-w-none space-y-8"
          dangerouslySetInnerHTML={{ __html: termsHtml }}
        />
      </article>
    </PublicLayout>
  );
};
